import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';
import { EconomyService, PriceListItem } from '../../../services/economy.service';

@Component({
    selector: 'tt-price',
    templateUrl: './price.component.html',
    styleUrls: ['./price.component.css'],
})
export class PriceComponent implements OnInit {
    priceGrpKeyno;

    public priceKeyno;

    public edit?: Edit;

    public selectListPrices: PriceListItem[] = [];

    public saving = false;

    public deleting = false;

    constructor(
        private stateService: StateService,
        private modal: ModalService,
        private datatask: DataTaskService,
        private economy: EconomyService,
    ) {
        this.priceGrpKeyno = this.stateService.getStateParams()['pricegrp_keyno'];
        this.priceKeyno = this.stateService.getStateParams()['price_keyno'];
    }

    private async loadEdit() {
        if (!!this.priceGrpKeyno && !!this.priceKeyno) {
            this.edit = (
                await this.datatask.Post(648, {
                    pricegrp_keyno: this.priceGrpKeyno,
                    price_keyno: this.priceKeyno,
                })
            )[0];
        }
    }

    private async loadPrices() {
        this.selectListPrices = await this.economy.getPriceLists();
    }

    private async retrievePriceList() {
        if (!!this.edit) {
            const response = (await this.datatask.Post(650, { pricelist_id: this.edit.pricelist_id }))[0];

            this.edit.pricelist_valuta_id = response?.pricelist_valuta_id;
            this.edit.tax_name = response?.tax_name;
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(649, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage,
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    public async deleteValues() {
        if (!!this.edit) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger',
                });

                if (deleteConfirmed) {
                    await this.datatask.Post(651, this.edit);

                    this.stateService.back();
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    public onChanged(_: string, id: keyof Edit) {
        switch (id) {
            case 'pricelist_id':
                if (!!this.edit?.pricelist_id) this.retrievePriceList();
                break;
            default:
                break;
        }
    }

    private async init() {
        this.loadEdit();
        this.loadPrices();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    price_keyno: number;
    prod_id: string;
    prod_name: string;
    prodsize_name: string;
    pricegrp_name: string;
    pricelist_name: string;
    pricenow: string;
    pricelist_id: string;
    pricelist_valuta_id: string;
    show_pricegrp_name: string;
    oldproductid: string;
    pricenext: string;
    tax_name: string;
    pricegrp_keyno: string;
    priceold: string;
    show_4_digits_in_price: string;
    show_setting: string;
}
